// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  Login,
  ResetPassword,
  ChangePassword,
  LoginAdmin,
} from './';

export default {
  path: 'login',
  name: 'Login',
  childRoutes: [
    { path: 'login', name: 'Login', component: Login, isIndex: true },
    { path: 'resetPassword', name: 'Reset password', component: ResetPassword },
    { path: 'changePassword', name: 'Change password', component: ChangePassword },
    { path: 'admin', name: 'Login admin', component: LoginAdmin },
  ],
};



// WEBPACK FOOTER //
// ./src/features/login/route.js